import { PackageDetails } from './PackageDetails';

export class Packages {
  packageDetails: PackageDetails[] = [];
}
